<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        title="Roles"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOW') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
                />
                <b-button
                  v-b-modal.modal-task-list
                  variant="primary"
                  @click="getTask()"
                >
                  <span class="text-nowrap">{{ $t('ADD_TASK_LIST') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="taskFields"
          :items="taskData"
        >
          <template #cell(action)="data">
            <b-link
              :to="{ name: 'tasklist-item-details', params: { id: data.item.id } }"
              class="margin-right: 15px; font-weight-bold d-block text-nowrap"
            >
              <feather-icon
                icon="EyeIcon"
              />
            </b-link>
            <!-- <feather-icon
              v-b-modal.modal-task-list
              icon="EyeIcon"
              @click="getTask()"
            /> -->
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOW') }} {{ from }} {{ $t('DEBTIA_TO') }} {{ to }} {{ $t('DEBTIA_OF') }} {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <add-modal
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getTaskList"
          :cases="cases"
          :debtors="debtors"
          :clients="clients"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination, BLink,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import AddModal from './AddModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    AddModal,
    BLink,
  },
  data() {
    return {
      loader: false,
      // taskFields: [
      //   { key: 'id', sortable: true },
      //   { key: 'title', sortable: true },
      //   'Action',
      // ],
      taskData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      modalLoader: true,
      constants,
      buttonTitle: '',
      cases: [],
      debtors: [],
      clients: [],
    }
  },
  computed: {
    taskFields() {
      return [
        { key: 'id', sortable: true, label: this.$t('DEBTIA_ID') },
        { key: 'title', sortable: true, label: this.$t('DEBTIA_TITLE') },
        { key: 'description', sortable: true, label: this.$t('DEBTIA_DESCRIPTION') },
        { key: 'Action', label: this.$t('DEBTIA_ACTION') },
      ]
    },
  },
  watch: {
    searchQuery: {
      handler() {
        this.getTaskList()
      },
    },
    currentPage: {
      handler() {
        this.getTaskList()
      },
    },
    perPage: {
      handler() {
        this.getTaskList()
      },
    },
  },
  created() {
    this.getTaskList()
  },
  methods: {
    async getTaskList() {
      try {
        this.loader = true
        const getTasks = await axios.get('/task-list/get-task-list', {
          params: {
            perPage: this.perPage,
            q: this.searchQuery,
            page: this.currentPage,
          },
        })
        if (getTasks.status) {
          this.taskData = getTasks.data.data.data
          this.totalPages = getTasks.data.data.total
          this.from = getTasks.data.data.from
          this.to = getTasks.data.data.to
          this.currentPage = getTasks.data.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getTask() {
      this.modalLoader = true
      this.cases = [{
        label: 'Select', value: 0,
      }]

      // this.buttonTitle = item.id > 0 ? 'Update' : 'Save'
      const args = []
      const data = await axios.get('get-debt-cases-list')
      if (data.status === 200) {
        // this.modalLoader = false
        // console.log('data-->', data)
        data.data.data.forEach(element => {
          args.push({ label: element.id, value: element.id })
        })

        this.cases.push(...args)
        // console.log(args)
      }
      const debtorargs = []
      const debtordata = await axios.get('/debtor/list?perPage=100000')
      if (debtordata.status === 200) {
        // this.modalLoader = false
        // console.log('data-->', data)
        debtordata.data.data.data.forEach(element => {
          debtorargs.push({ label: `${element.id}- ${element.name}`, value: element.id })
        })

        this.debtors.push(...debtorargs)
        // console.log(args)
      }
      const clientsargs = []
      const clientsdata = await axios.get('/clients/list-all?perPage=100000')
      if (clientsdata.status === 200) {
        this.modalLoader = false
        // console.log('data-->', data)
        clientsdata.data.data.data.forEach(element => {
          clientsargs.push({ label: `${element.id}- ${element.name}`, value: element.id })
        })

        this.clients.push(...clientsargs)
        // console.log(args)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
